import { render, staticRenderFns } from "./vendor-info.vue?vue&type=template&id=1e8743aa&"
import script from "./vendor-info.vue?vue&type=script&lang=js&"
export * from "./vendor-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports